import { render, staticRenderFns } from "./show_pic.vue?vue&type=template&id=60c6ad60&scoped=true&"
import script from "./show_pic.vue?vue&type=script&lang=js&"
export * from "./show_pic.vue?vue&type=script&lang=js&"
import style0 from "./show_pic.vue?vue&type=style&index=0&id=60c6ad60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6ad60",
  null
  
)

export default component.exports